import React from "react";

const Loader = () => {
  return (
    <>
      <div className="loader-overlay">
        <div className="loader-spinner"></div>
      </div>

      <style>{`
        .loader-overlay {
          position: fixed;
          inset: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }

        .loader-spinner {
          width: 45px;
          height: 45px;
          border: 4px solid #e5e7eb;
          border-top: 4px solid #45728B;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default Loader;